import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { useTranslation } from 'react-i18next';

import { messageInputTextareaStyle } from '@/pages/Messenger/styles.ts';
import Send from '@/components/common/svg/Send.tsx';

interface MessageInputBottomBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  isDisabled: boolean;
  isSystem?: boolean;
  textAreaRef?: React.RefObject<HTMLTextAreaElement>;
  onFocus?: () => void;
  onBlur?: () => void;
}

const MessageInputBottomBar: React.FC<MessageInputBottomBarProps> = ({
  value,
  onChange,
  onSend,
  isDisabled,
  isSystem = false,
  textAreaRef,
  onFocus,
  onBlur
}) => {
  const { t } = useTranslation();

  return (
    <>
      <TextareaAutosize
        ref={textAreaRef}
        maxRows={2}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={isSystem}
        style={messageInputTextareaStyle()}
        placeholder={t('message.input_placeholder')}
      />

      <button
        type="button"
        tabIndex={-1}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onSend}
        disabled={isDisabled}
        style={{
          marginLeft: 8,
          width: 35,
          height: 35,
          border: 'none',
          borderRadius: '50%',
          background: isDisabled ? '#ccc' : '#000',
          color: '#fff',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Send style={{ marginRight: 2 }} />
      </button>
    </>
  );
};

export default MessageInputBottomBar;
